import {ObjectId} from './object.model';
import {UserId} from './user';

export type HubId = ObjectId;

export enum HubType {
  Cloud = 'cloud',
  OnPrem = 'onprem'
}

export interface Hub {
  ID: HubId;
  Name: string;
  Owner: UserId;
  Token: '';
  Tunnel: number;
  PublicIP: string;
  LocalIP: string;
  InterfaceIP: string;
  TimeZone?: HubTimeZone;
  Type?: HubType;
}

export const HUB_TIMEZONES = [
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Phoenix',
  'America/Los_Angeles',
  'America/Anchorage',
  'Pacific/Honolulu',
] as const;

export type HubTimeZone = typeof HUB_TIMEZONES[number];

export function getFriendlyTimeZoneString(tz: HubTimeZone): string {
  switch (tz) {
    case 'America/New_York':
      return 'US Eastern: America/New_York';
    case 'America/Chicago':
      return 'US Central: America/Chicago';
    case 'America/Denver':
      return 'US Mountain: America/Denver';
    case 'America/Phoenix':
      return 'US Arizona: America/Phoenix';
    case 'America/Los_Angeles':
      return 'US Pacific: America/Los_Angeles';
    case 'America/Anchorage':
      return 'US Alaska: America/Anchorage';
    case 'Pacific/Honolulu':
      return 'US Hawaii: Pacific/Honolulu';
    default:
      return tz;
  }
}

export interface LorawanGateway {
  ID: string;
  EUI: string;
  LastReceivedAt: string | null;
  LastAlarmedAt: string | null;
  HubID: HubId;
}

export interface HubDistInfo {
  Version: string;
  InstallCommands: string[];
  UpgradeCommands: string[];
}
